import { render, staticRenderFns } from "./UITimePicker.vue?vue&type=template&id=85389f7e&scoped=true"
import script from "./UITimePicker.vue?vue&type=script&lang=js"
export * from "./UITimePicker.vue?vue&type=script&lang=js"
import style0 from "./UITimePicker.vue?vue&type=style&index=0&id=85389f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85389f7e",
  null
  
)

export default component.exports